import React from 'react';

export function SortControls({ t, sortBy, setSortBy, sortDir, setSortDir }) {
  return (
    <div className="flex items-center justify-end gap-2 sm:gap-3 mb-4 flex-wrap">
      <span className="text-xs text-slate-400">{t('sortBy')}</span>
      <select
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value)}
        className="bg-slate-800 border border-slate-600 rounded-lg px-3 py-1.5 text-sm text-white focus:ring-2 focus:ring-emerald-500 outline-none"
      >
        <option value="profit">{t('netProfit')}</option>
        <option value="price">{t('purchasePrice')}</option>
      </select>
      <select
        value={sortDir}
        onChange={(e) => setSortDir(e.target.value)}
        className="bg-slate-800 border border-slate-600 rounded-lg px-3 py-1.5 text-sm text-white focus:ring-2 focus:ring-emerald-500 outline-none"
      >
        <option value="desc">{t('highToLow')}</option>
        <option value="asc">{t('lowToHigh')}</option>
      </select>
    </div>
  );
}

export default SortControls;
